let mapper_options = {
  endpoint: 'registration_keys',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      user: {
        foreignKey: 'user_id',
        localField: 'user'
      },
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      },
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('registration_key', mapper_options)
}